import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { NoiseMeter } from "./NoiseMeter";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const loreCards = [
  {
    title: "WHY SILENCE BECAME LAW",
    text: "After the Second Apocalypse, sustained noise began attracting mutated wildlife, exposing safehouse routes, and giving hostile crews an acoustic map of civilian movement. Safe zones adopted mandatory quiet hours from 22:00 to 06:00 to keep residential sectors hidden after dark.",
  },
  {
    title: "WHO ENFORCES THE ORDINANCE",
    text: "The Aether-Grid Audit Division maintains the public decibel mesh, while Black-Ops Net acoustic units respond to deliberate violations. Together they monitor noise spikes without exposing the location of protected safehouse channels.",
    sigils: [
      {
        src: "/assets/agad-sigil.png",
        alt: "AGAD — The Aether-Grid Audit Division emblem",
        testid: "agad-sigil-image",
      },
      {
        src: "/assets/bonau-sigil.png",
        alt: "BONAU — Black-Ops Net Acoustic Units emblem",
        testid: "bonau-sigil-image",
      },
    ],
  },
  {
    title: "WHAT AN AUDIT MEANS",
    text: "A first violation triggers an automated signal warning. Repeated breaches can suspend market access, route permits, power allocation, and courier privileges until the source is inspected and cleared.",
  },
];

export function SilentNightLore() {
  const [open, setOpen] = useState(false);

  return (
    <section className="silent-night-lore" data-testid="silent-night-lore-section">
      <div className="silent-night-head">
        <SectionHeading
          eyebrow="SILENT NIGHT ARCHIVE"
          title="Quiet hours keep the city alive."
          text="The noise ordinance is not crowd control. It is acoustic camouflage for every safe zone still connected to the network."
        />
        <button
          type="button"
          className={`manifesto-toggle silent-night-toggle ${open ? "is-open" : ""}`}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          data-testid="silent-night-toggle"
        >
          {open ? "SEAL THE ARCHIVE" : "OPEN THE ARCHIVE"}
          <ChevronDown size={15} />
        </button>
      </div>
      <div className={`manifesto-collapse ${open ? "is-open" : ""}`} data-testid="silent-night-collapse">
        <div className="manifesto-collapse-inner">
          <div className="silent-law-grid">
            {loreCards.map((card, index) => (
              <Reveal className="silent-law-card" delay={index * 0.07} key={card.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
                {card.sigils ? (
                  <div className="silent-law-sigils" data-testid="enforcement-sigils">
                    {card.sigils.map((sigil) => (
                      <img loading="lazy" data-testid={sigil.testid} key={sigil.src} src={sigil.src} alt={sigil.alt} />
                    ))}
                  </div>
                ) : null}
              </Reveal>
            ))}
          </div>
          <Reveal className="silent-law-note" delay={0.2}>
            <span>ENFORCEMENT PROTOCOL</span>
            <p>
              Wasteland Runners are trained to move below the 50 dB threshold using hand signals, insulated cargo
              locks, and low-frequency route pings. Violations are logged to the local security ledger before an
              auditor is dispatched.
            </p>
          </Reveal>
          <NoiseMeter />
        </div>
      </div>
    </section>
  );
}
